<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
const props = defineProps<{
	value: number
	max: number
	title: string
	description?: string
	color?: string
}>()

const percentage = computed(() => Math.min(100, Math.max(0, (props.value / props.max) * 100)))
const strokeColor = computed(() => props.color || '#3b82f6')
</script>

<template>
	<div class="flex flex-col items-center p-4 border rounded-lg bg-background">
		<div class="relative w-24 h-24 mb-3">
			<svg class="w-full h-full" viewBox="0 0 100 100">
				<!-- Background circle -->
				<circle
						cx="50"
						cy="50"
						r="45"
						fill="none"
						stroke="#e5e7eb"
						stroke-width="8"
						/>
				<!-- Progress circle -->
				<circle
						cx="50"
						cy="50"
						r="45"
						fill="none"
						:stroke="strokeColor"
						stroke-width="8"
						stroke-linecap="round"
						:stroke-dasharray="283"
						:stroke-dashoffset="283 - (283 * percentage) / 100"
						transform="rotate(-90 50 50)"
						/>
			</svg>
			<div class="absolute inset-0 flex items-center justify-center">
				<span class="text-xl font-bold">{{ Math.round(percentage) }}%</span>
			</div>
		</div>
		<h3 class="text-lg font-semibold">{{ title }}</h3>
		<p v-if="description" class="text-sm text-muted-foreground text-center mt-1">
		{{ description }}
		</p>
		<div class="mt-2 text-sm">
			<span class="font-medium">{{ value }}</span>
			<span class="text-muted-foreground"> / {{ max }} target</span>
		</div>
	</div>
</template>
